import { Stack, Typography, Avatar, SxProps } from "@mui/material";

type IconTitleProps = {
    icon: React.ReactNode
    title: string
    sx?: SxProps
}

export default function IconTitle({ icon, title, sx }: IconTitleProps) {
    return <Stack direction="row" alignItems="center" spacing={1} sx={sx}>
        <Avatar sx={{ bgcolor: "primary.main" }} variant="rounded">
            {icon}
        </Avatar>
        <Typography variant="h6" component="h3">{title}</Typography>
    </Stack>

}
